import React, { useState } from "react";
import { Form } from "react-bootstrap";

const StockReport = ({ history }) => {
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);

  const filteredHistory = history.filter((item) => {
    const itemMonth = new Date(item.date).getMonth() + 1;
    return itemMonth === selectedMonth;
  });

  return (
    <div className="mt-4">
      <h5>📅 Monthly Stock Report</h5>
      <Form.Select
        className="mb-3"
        value={selectedMonth}
        onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
      >
        {[...Array(12).keys()].map((month) => (
          <option key={month + 1} value={month + 1}>
            {new Date(2022, month).toLocaleString("default", { month: "long" })}
          </option>
        ))}
      </Form.Select>
      <div className="card table-responsive">
        <table className="table table-hover table-vcenter table-sm">
          <thead>
            <tr>
              <th>No</th>
              <th>Product</th>
              <th>Change</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {filteredHistory.length > 0 ? (
              filteredHistory.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.product}</td>
                  <td
                    className={item.change > 0 ? "text-success" : "text-danger"}
                  >
                    {item.change > 0 ? `+${item.change}` : item.change}
                  </td>
                  <td>{item.date}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center">
                  No data available for this month
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StockReport;
